module.exports = __webpack_public_path__ + "img/login_dec01.0843a6cb.png";